// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetContext, ActionSheetV2, LgPadding } from '@alto/design-system';
import React, { useContext } from 'react';
import { Platform } from 'react-native';
import { type PaymentMethodType } from '~shared/constants';
import { AddPaymentCard } from './AddPaymentCard';

type Props = {
  readonly paymentMethodType: PaymentMethodType;
  // Skip the PaymentSheet gate and render the legacy card form directly - used when
  // a host already tried the PaymentSheet and is falling back.
  readonly forceLegacy?: boolean;
};

export const AddPaymentCardActionSheet = ({ paymentMethodType, forceLegacy }: Props) => {
  const { closeActionSheet } = useContext(ActionSheetContext);

  return (
    <ActionSheetV2
      handleClose={closeActionSheet}
      title="Add credit or debit card"
      analyticsName="add payment card"
      keyboardAvoiding={Platform.OS === 'ios' || Platform.OS === 'android'}
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <AddPaymentCard
          onClose={closeActionSheet}
          paymentMethodType={paymentMethodType}
          forceLegacy={forceLegacy}
        />
      </LgPadding>
    </ActionSheetV2>
  );
};
